<script lang="ts" setup>
import {
  type PropType,
  computed,
  nextTick,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from '#imports';
import type { DrawGoodsVo, GoodsVO } from '~/types/auto/actuator';
import BadgeWrapper from '../BadgeWall/BadgeWrapper.vue';
import UnpackBoxItem from './UnpackBoxItem.vue';

const props = defineProps({
  goods: {
    type: Object as PropType<GoodsVO>,
    default: () => ({}),
  },
  size: {
    type: Number,
    default: 200,
  },
  animate: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['boxOpen', 'boxOpenOk', 'playSound']);
const isRunningLottie = ref(true);

const mainContentVisible = ref(!props.animate);

//78是图片下的标题高度
const itemTotalHeight = computed(() => props.size + 78);
const boxOpen = () => {
  mainContentVisible.value = true;
  emit('boxOpen');
};

const boxOpenOk = () => {
  emit('boxOpenOk');
};

watch(
  () => props.animate,
  (newVal) => {
    if (!newVal) {
      boxOpen();
      boxOpenOk();
    }
  },
);
</script>
<template>
  <div
    :style="{ '--size': size + 'px', height: itemTotalHeight + 'px' }"
    class="relative w-[var(--size)]"
  >
    <UnpackBoxItem
      v-if="animate"
      :loop="goods.url === undefined"
      @box-open="boxOpen"
      @box-open-ok="boxOpenOk"
      @play-sound="emit('playSound')"
    />
    <Transition name="fade-up">
      <div v-show="mainContentVisible">
        <div class="h-[var(--size)] w-full">
          <BadgeWrapper
            :image="goods.url"
            :video="goods.video"
            :level="goods.goodsAnimation"
            :level-up="goods.levelUp"
            :is-new="goods.new"
          />
        </div>
      </div>
    </Transition>
    <Transition name="fade">
      <div v-show="mainContentVisible" class="mt-4 text-center">
        <p class="overflow text-base font-bold">{{ goods.name }}</p>
        <p class="overflow mt-[6px] flex-center">
          <a-rate
            class="reverse !text-base !leading-[22px] !-mt-0.5"
            :value="goods.goodsLevel"
            :count="3"
            disabled
          />
          <span class="ml-2 text-sm text-white">
            <span>{{ goods.goodsNum || 0 }}</span>
            <span v-if="goods.levelNum">/{{ goods.levelNum }}</span>
          </span>
        </p>
      </div>
    </Transition>
  </div>
</template>
<style scoped>
.overflow {
  @apply overflow-hidden text-ellipsis whitespace-nowrap;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition:
    opacity 1.8s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-up-enter-from,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(40px);
}
.fade-up-enter-to,
.fade-up-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.8s 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
